import { render, staticRenderFns } from "./MedicalContentTemplateShow.vue?vue&type=template&id=1604da74&scoped=true&"
import script from "./MedicalContentTemplateShow.vue?vue&type=script&lang=js&"
export * from "./MedicalContentTemplateShow.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentTemplateShow.vue?vue&type=style&index=0&id=1604da74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1604da74",
  null
  
)

export default component.exports